'use strict';

var angular = require('angular');
var moment = require('moment');

angular
  .module('mwl.calendar')
  .constant('moment', moment);



/*****************
 ** WEBPACK FOOTER
 ** ./src/services/moment.js
 ** module id = 28
 ** module chunks = 0
 **/